export const DashboardAnswersDutch = (text, type, section) => {
  // console.log("text: ",text,"type: ",type,"section: ",section);
  switch (section) {
    case "strongly-agree":
      return "Zeer mee eens";
    case "agree":
      return "Mee eens";
    case "neutral":
      return "Neutraal";
    case "disagree":
      return "Oneens";
    case "strongly-disagree":
      return "Zeer oneens";
    case "people-experienced-holy-spirit":
      return "Mensen in de parochie hebben de transformerende kracht van de Heilige Geest in hun leven ervaren.";
    case "people-recognize-gifts":
      return "Mensen in onze parochie herkennen de gaven van de Heilige Geest in hun leven.";
    case "parish-transformed-encounter-god":
      return "De parochie is getransformeerd door de ontmoeting van mensen met God.";
    case "people-understand-holy-spirit-person":
      return "Mensen in onze parochie begrijpen dat de Heilige Geest een persoon is met wie je een relatie kunt hebben.";
    case "without-holy-spirit-power":
      return "Zonder de kracht van de Heilige Geest die in het leven van mensen werkt, zou onze parochie niet zijn waar ze nu is.";
                  
    default:
      return text;
  }
}
